<template>
  <div class="overlay">
    <div class="content" v-if="yearDetails">
      <header class="header">
        <label>
          <strong>{{ `${__('The year')} ${yearDetails?.year}` }}</strong>
          <span>{{
            __(
              'Total payment: {0} NIS',
              [
                __u_value__({
                  value: yearDetails.total,
                  unit: 'number-f',
                }),
              ],
              1
            )
          }}</span>
        </label>
        <!-- <router-link class="close" :to="{ name: 'FinancialReport' }"> -->
        <i-icon class="close" name="cancel" @click="close" />
        <!-- </router-link> -->
      </header>
      <p-vue-table
        dataKey="id"
        :value="yearDetails.report"
        :rowClass="selectedRow"
        responsiveLayout="scroll"
        v-if="!displayOnly"
      >
        <p-vue-column
          field="month"
          :header="__('A month')"
          headerStyle="width: 21%"
        >
          <template #body="{ data }">
            <span>{{ __(data.Month) }}</span>
          </template>
        </p-vue-column>
        <p-vue-column field="Hov" :header="__('Sum')"></p-vue-column>
        <p-vue-column field="Payed" :header="__('Paid up')"></p-vue-column>
        <p-vue-column field="Itra" :header="__('Balance')"></p-vue-column>

        <p-vue-column field="selected" :header="__('Add to payment')">
          <template #body="{ data }">
            <div class="p-d-flex p-ai-center">
              <p-vue-checkbox
                :disabled="data.HasPandingCheck"
                :binary="true"
                v-model="data.selected"
                @click="$emit('addToPayment', data)"
              />
              <div v-if="data.HasPandingCheck" class="hasPandingCheck-alert">
                <i
                  class="pi pi-exclamation-circle"
                  style="font-size: 1.2rem"
                ></i>
                <div>{{ __("צ'ק ממתין לאישור") }}</div>
              </div>
            </div>
            <!-- <span
              :class="{
                'payment-status': true,
                'paid-up': data.selected === true,
              }"
              @click="$emit('addToPayment', data)"
            >
              {{
                __(data.selected ? "- Added to payment" : "+ Add to payment")
              }}
            </span> -->
          </template>
        </p-vue-column>
      </p-vue-table>

      <p-vue-table
        dataKey="id"
        :value="yearDetails.report"
        responsiveLayout="scroll"
        v-if="displayOnly"
      >
        <p-vue-column
          field="month"
          :header="__('A month')"
          headerStyle="width: 25%"
        >
          <template #body="{ data }">
            <span>{{ __(data.Month) }}</span>
          </template>
        </p-vue-column>
        <p-vue-column field="Hov" :header="__('Sum')"></p-vue-column>
        <p-vue-column field="Payed" :header="__('Paid up')"></p-vue-column>
        <p-vue-column field="Itra" :header="__('Balance')"> </p-vue-column>
      </p-vue-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: Function,
    yearDetails: Object,
    displayOnly: Boolean,
  },

  emits: ['addToPayment'],
  mounted() {
    // console.log(this.yearDetails);
  },
  methods: {
    select() {
      // appUpdateFeeSelection
    },
    selectedRow(data) {
      return {
        'selected-row': data.selected,
        'pending-check-row': data.HasPandingCheck,
      }
    },
  },
}
</script>

<style scoped>
.overlay {
  flex: 1;

  display: flex;
  flex-direction: column;

  height: 100%;

  padding: 3px;

  background-color: rgba(0, 0, 0, 0.301);
}

.content {
  flex: 1;

  background-color: white;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  padding: 15px;
}

:deep(.close.svg) {
  width: 14px;
  height: 14px;

  color: var(--color-success);
}

.header label {
  display: flex;
  flex-direction: column;

  font-size: 18px;
  line-height: 0.93;
  letter-spacing: 0.48px;
  color: var(--color-primary);
}

.header label strong {
  font-weight: normal;
}

.header label span {
  margin-top: 10px;

  font-size: 15px;
}

.payment-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.45px;
  color: var(--color-success-hover);
}

.payment-status.paid-up {
  color: var(--color-primary);
}

.payment-status:deep(.svg) {
  width: 13px;
  height: 13px;

  margin-left: 4px;
}

:deep(.selected-row) {
  background-color: #55ad003b !important;
}
:deep(.pending-check-row) {
  background-color: #ebe7e7 !important;
}

:deep(.pending-check-row td) {
  color: #878282 !important;
}
:deep(.hasPandingCheck-alert) {
  font-size: 13px;
  color: #cf7476;
  margin-inline-start: 10px;
}
</style>
